/* The Haaland Code — direct "Order Now" buy-now behavior. Adds the configured
   variant to the Shopify cart via the Cart AJAX API, then redirects straight
   to Shopify's native secure checkout. No payment data is collected locally. */
(function () {
  'use strict';

  window.HC = window.HC || {};

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function setLoading(btn, loading) {
    if (!btn) return;
    if (loading) {
      btn.setAttribute('data-loading', 'true');
      btn.setAttribute('aria-busy', 'true');
    } else {
      btn.removeAttribute('data-loading');
      btn.removeAttribute('aria-busy');
    }
  }

  /**
   * Adds a variant to the cart and redirects to /checkout.
   * Falls back to a product URL if no variant is configured.
   */
  HC.addToCartAndRedirect = function addToCartAndRedirect(variantId, quantity, opts) {
    opts = opts || {};
    const btn = opts.button;
    const errorEl = opts.errorEl;

    if (!variantId) {
      if (opts.fallbackUrl) {
        window.location.href = opts.fallbackUrl;
      }
      return Promise.resolve();
    }

    setLoading(btn, true);
    if (errorEl) errorEl.textContent = '';

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: quantity || 1 }] }),
    })
      .then(function (res) {
        if (!res.ok) {
          return res.json().then(function (data) {
            throw new Error((data && data.description) || 'This item could not be added to your cart.');
          });
        }
        return res.json();
      })
      .then(function () {
        HC.track('product_add_to_cart', { variant_id: variantId, quantity: quantity || 1 });
        HC.track(opts.eventName || 'product_order_now_click', { variant_id: variantId });
        document.dispatchEvent(new CustomEvent('hc:cart:updated'));
        window.location.href = '/checkout';
      })
      .catch(function (err) {
        setLoading(btn, false);
        if (errorEl) errorEl.textContent = err.message || 'Something went wrong. Please try again.';
      });
  };

  function initDirectBuyButtons() {
    document.querySelectorAll('[data-hc-direct-buy]').forEach(function (btn) {
      let submitting = false;

      btn.addEventListener('click', function (event) {
        event.preventDefault();
        if (submitting || btn.getAttribute('aria-disabled') === 'true' || btn.disabled) return;

        const needsSelector = btn.getAttribute('data-needs-selector') === 'true';
        if (needsSelector) {
          document.dispatchEvent(new CustomEvent('hc:open-format-modal', { detail: { trigger: btn } }));
          return;
        }

        const variantId = btn.getAttribute('data-variant-id');
        const fallbackUrl = btn.getAttribute('data-fallback-url');
        const errorId = btn.getAttribute('data-error-target');
        const errorEl = errorId ? document.getElementById(errorId) : null;

        submitting = true;
        HC.addToCartAndRedirect(variantId, 1, {
          button: btn,
          errorEl: errorEl,
          fallbackUrl: fallbackUrl,
          eventName: btn.getAttribute('data-hc-event'),
        }).finally(function () {
          submitting = false;
        });
      });
    });
  }

  ready(initDirectBuyButtons);
})();
